<template>
  <div class="rootDiv">
    <div class="title-div">
      <div :style="{'float': 'left','width': '30%','visibility':model.backTitle!==null?'visible':'hidden'}">
        <Button style="background-color: #67b676;color: black;" @click="backPage">
          <img src="../../../assets/images/32/back.png" height="32" width="32" slot="icon" alt="">
          <span style="font-size: 0.8rem">{{ model.backTitle }}</span>
        </Button>
      </div>
      <div style="float: left;width: 40%;text-align: center;margin-top: 0.2rem">
        <span>{{ model.title }}</span>
      </div>
      <div style="float: right;width: 30%;text-align: right">
        <img style="margin-right: 10px;margin-top: 5px" src="../../../assets/images/32/search.png" height="32"
             width="32" slot="icon" alt="" @click="searchVillage">
      </div>
      <div style="clear: both"></div>
    </div>
    <Cell :title="item.mC" v-for="item in ItemList" :key="item.iD" class="cellstyle" v-on:click.native="Go(item)"
          :is-link="!item.final">
      <img slot="icon" src="../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
    </Cell>
  </div>
</template>

<script>
import {Cell, Button, Indicator} from "mint-ui";

export default {
  name: "Region",
  components: {
    Cell, Button
  },
  data() {
    return {
      ItemList: [],
      model: {title: '全国', backTitle: null, id: 0, data: []},
      token: localStorage.getItem('token'),
      getChildrenListUrl: '/api/mzb/getChildrenList',
    }
  },
  mounted() {
    if (this.$route.params.isBack === '1') {
      let record = localStorage.getItem("Record_Region_List")
      let record_json = JSON.parse(record)
      const record_array = [];
      for (let i in record_json) {
        record_array.push(record_json [i])
      }
      this.model = record_array[record_array.length - 1]
      this.ItemList = this.model.data
    } else {
      localStorage.setItem('Record_Region_List', null)
      this.getItemList(this.model.id)
    }
  },
  methods: {
    searchVillage() {
      this.$router.push({name: 'm_region_search', params: {sigle: '1'}})
    },
    backPage() {
      let record = localStorage.getItem("Record_Region_List")
      let record_json = JSON.parse(record)
      const record_array = [];
      for (let i = 0; i < record_json.length - 1; i++) {
        record_array.push(record_json [i])
      }
      localStorage.setItem('Record_Region_List', JSON.stringify(record_array))
      this.model = record_array[record_array.length - 1]
      this.ItemList = this.model.data
    },
    Go(item) {
      if (!item.final) {
        this.model = {title: item.mC, backTitle: this.model.title, id: item.iD}
        this.getItemList(this.model.id)
      }
    },
    getItemList(fID) {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getChildrenListUrl,
        params: {parentID: fID},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ItemList = response.data['responseData']

            let record_json = JSON.parse(localStorage.getItem("Record_Region_List"))
            const record_array = [];
            for (let i in record_json) {
              record_array.push(record_json [i])
            }
            that.model.data = that.ItemList
            record_array.push(that.model)
            localStorage.setItem('Record_Region_List', JSON.stringify(record_array))
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.title-div {
  background-color: #67b676;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  text-align: left;

  span {
    font-size: 1.4rem;
    color: white;
  }
}

.rootDiv {
  margin-top: -0.5rem;
}
</style>
